export class HttpError extends Error {
    request;
    response;
    constructor(request, response) {
        super(`HTTP ${response.status} ${response.statusText}`);
        this.request = request;
        this.response = response;
        this.name = 'HttpError';
        Object.defineProperty(this, 'request', { enumerable: false });
        Object.defineProperty(this, 'response', { enumerable: false });
    }
}
//# sourceMappingURL=HttpError.js.map